import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/messaging'
import axios from "axios";
import store, {BASE_API_URL, storage} from "../store";
import {removeServiceWorkers} from '@/utils';

let globalMessaging = false;
let globalApp = false;

const FCM = () => {

  let serviceworker = `firebase-messaging-sw.js`; // Desktop
  if (store.getters.device.os.name.toLowerCase() === 'android') {
    serviceworker = `firebase-messaging-sw-android.js`; // Android
  }

  navigator.serviceWorker.register(
    `${process.env.BASE_URL}${serviceworker}?client=${store.state.clientSlug}&apiUrl=${BASE_API_URL}`,
    {scope: `${process.env.BASE_URL}firebase-cloud-messaging-push-scope`}
  )
  .then((registration) => {
    if (firebase.messaging.isSupported() && store.state.firebaseConfig) {
      if (!firebase.apps.length) {
        globalApp = firebase.initializeApp(store.state.firebaseConfig);
      }

      const messaging = firebase.messaging();
      messaging.useServiceWorker(registration);

      getToken(messaging);

      messaging.onTokenRefresh(function() {
        storage.setItem('fcmTokenSent', 0)
        getToken(messaging);
      });


      if ('permissions' in navigator) {
        navigator.permissions.query({name: 'notifications'}).then((notificationPermission) => {
          notificationPermission.onchange = function() {
            messaging.getToken().then((token) => {
              if (notificationPermission != 'granted') {
                storage.setItem('fcmTokenSent', 0);
                if (notificationPermission === 'denied' && token) {
                  sendTokenToServer(token, false);
                }
              } else {
                storage.setItem('fcmTokenSent', 1);
                sendTokenToServer(token, true);
              }
            }).catch(() => {
              console.log('Unable to retrieve refreshed token ');
            });
          };
        });
      }

      messaging.onMessage((payload) => {
        store.dispatch('setPushNotification', payload);
      });

      globalMessaging = messaging;
    }
  });
};

function getToken(messaging) {
  messaging.getToken().then((token) => {
    if (token) {
      if (!storage.getItem('fcmTokenSent') || storage.getItem('fcmTokenSent') != 1) {
        sendTokenToServer(token, true)
      }
    } else {
      console.log('No Instance ID token available. Request permission to generate one.');
    }
  }).catch(() => {
    console.log('Unable to retrieve refreshed token ');
  });
}

function sendTokenToServer(token, permission) {

  const body = {
    fcm_registration_token: token,
    fcm_permission: permission,
    device_info: {
      user_agent: navigator.userAgent,
      app_version: 1,
      system_name: store.getters.device.client.name,
      system_version: store.getters.device.client.version,
      app_type: 'web',
      device_model: store.getters.device.device.brand + ' ' + store.getters.device.device.type,
      device_type: store.getters.device.os.name + ' ' + store.getters.device.os.version
    },
  };

  axios.post(`${BASE_API_URL}/api/v1/customer-relationships/${store.state.client_id}/fcm-registration-token/`, JSON.stringify(body))
    .then(() => {
      store.dispatch('pushNotificationRegistration', {mode: 'success'});
    }).catch((error) => {
      store.dispatch('pushNotificationRegistration', {mode: 'error', data: error});
      console.error(error);
    });
}

export function deleteToken() {
  if (globalMessaging) {
    globalMessaging.getToken().then((currentToken) => {
      globalMessaging.deleteToken(currentToken).then(() => {
        removeServiceWorkers();
        globalMessaging = false;
      })
    });
  }
  if (globalApp) {
    globalApp.delete().then(() => {
      globalApp = false;
    })
  }
}

export default FCM;
